module.exports = __webpack_public_path__ + "static/icons/icon-heart--red-cdd6c8ec88c48f995e9a07d8b5a3a0c4.svg";